import React from "react";
import Select from "react-select";
 import 'react-select/dist/react-select.min.css';

export default class DropdownComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: "",
        }
    }

    getOptions() {
        let options = [];
        let proptions = this.props.options || [];
        if (proptions.length > 0) {

            let optionValueField = this.props.optionValue || (proptions[0]["id"] !== undefined ? "id" : "value");
            let optionTextField = this.props.optionText || (proptions[0]["name"] !== undefined ? "name" : "text");

            proptions.forEach((oneOption, index) => {

                let value = oneOption[optionValueField];
                let label = this.props.getOptionText === undefined ? oneOption[optionTextField] : this.props.getOptionText(oneOption, index);

                if (label === undefined) label = "No valid optionText found";

                options.push({
                    value: value,
                    label: label,
                    data: oneOption
                });
            });
        }
        return options;
    }

    handleChangeEvent(selectedValue) {
        if (this.props.onChange) {
            let data = selectedValue === null ? null : selectedValue.data;
            this.props.onChange(data);
        }
        if (this.props.value === undefined) {
            this.setState({
                value: selectedValue === null ? "" : selectedValue.value,
            })
        }
    }

    render() {
        let isSearchable = this.props.disableSearch === undefined || !this.props.disableSearch;
        let borderColor = this.props.invalid === true ? "#f86c6b" : this.props.valid === true ? "#4dbd74" : undefined;
        return <Select
            style={borderColor === undefined
                ? this.props.style
                : {
                    borderColor: borderColor,
                    ...this.props.style
                }
            }
            className={this.props.className}

            name="form-field-add-param"
            value={this.props.value || this.state.value}
            options={this.getOptions()}
            placeholder={this.props.placeholder || "Select option"}

            disabled={this.props.disabled}
            searchable={isSearchable}
            clearable={true}
            isValid={this.props.isValid}
            isInvalid={this.props.isInvalid}

            onChange={this.handleChangeEvent.bind(this)}
            onBlur={this.props.onBlur}
        />

    }
}
